//@flow
import type { HProps } from "./H";
import type { BaseComponentProps } from "../base-component/BaseComponent";
import * as React from "react";
import { Text, View, ScrollView, Image } from "react-native";
import H from "./H";

export type H1Props = HProps & {};
export type H1State = {};

export const H1Style = {
  fontSize: 20
};

export default class H1 extends React.Component<H1Props, H1State> {
  render() {
    return <H {...this.props} style={{ ...H1Style, ...this.props.style }}>{this.props.children}</H>;
  }
}
